import './Contact.css';

import { IonCard, IonCardContent, IonContent, IonItem, IonLabel, IonPage, IonText, useIonToast } from '@ionic/react';
import { chatboxOutline, mailOutline, personOutline, phonePortraitOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';

import ActionButton from '../../components/button/ActionButton';
import InputItem from '../../components/input/InputItem';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { DataProvider } from '../../library/DataProvider';
import { ContactPostAction } from '../../redux/actions/Contact';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useHistory } from 'react-router';

const Contact: React.FC = (props) => {
const history = useHistory();
const [toast, dismiss] = useIonToast();

const dispatch = useAppDispatch()
const formContact = useAppSelector(state => state.contactPost)
const { form_loading, resp } = formContact

const [form, setForm] = useState({
  fullName: { value: "", validation: { required: true }, error: "" },
  mobile: { value: "", validation: { required: true, min: 11, max: 11 }, error: "" },
  subject: { value: "", validation: { required: true }, error: "" },
  message: { value: "", validation: { required: true }, error: "" }
});

const [formProvider] = useState(() => new DataProvider(form, setForm));

const contactFormSubmitHandler = (e: any) => {
  e.preventDefault();

  let formValidation = formProvider.validation(form);

  if (formValidation) {
    dispatch(ContactPostAction(form.fullName.value, form.mobile.value, form.subject.value, form.message.value))
  }
}

useEffect(() => {
  const formDone = () => {
    if (resp != null && !form_loading) {
      if (resp.result) {
        toast({ message: resp.message, duration: 2000, color: "primary" })

        formProvider.reset();
      } else {
        toast({ message: resp.message, duration: 2000, color: "danger" })
      }
    }
  }

  formDone();
}, [form_loading])

return (
  <IonPage className="contact">
    <Toolbar title="ارتباط با ما" hasBackButton />

    <LayoutGap />

    <IonContent className="main-content">
      <IonCard>
        <IonCardContent>
          <div className="ion-margin-bottom">
            {(history.location.state as any)?.contact?.map((el: any, index: number) => {
              return <IonItem>
                <IonLabel color="medium">{index == 0 ? "" : el.title}</IonLabel>
                <IonText>{el.value}</IonText>
              </IonItem>
            })}
          </div>

          <form onSubmit={contactFormSubmitHandler}>
            <InputItem name="fullName" type="text" label="نام کامل" icon={personOutline} maxlength={50} provider={formProvider} />

            <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={11} ltr spaced provider={formProvider} />

            <InputItem name="subject" type="text" label="موضوع" icon={mailOutline} maxlength={100} provider={formProvider} />

            <InputItem name="message" type="textarea" label="پیام شما" icon={chatboxOutline} maxlength={1000} rows={3} provider={formProvider} />

            <ActionButton text="ارسال پیام" loading={form_loading} />
          </form>
        </IonCardContent>
      </IonCard>
    </IonContent>
  </IonPage>
)
}

export default Contact